module.exports = __webpack_public_path__ + "static/media/DiscGuard Termes & Conditions.1e338701.pdf";